import { KeyValue } from "@/main/models/common";

export enum PredefinedSearchTypes {
  GET_DOMAIN_PREDEFINED_SEARCH = '@predefinedSearch/GET_DOMAIN_PREDEFINED_SEARCH',
  SAVE_DOMAIN_PREDEFINED_SEARCH = '@predefinedSearch/SAVE_DOMAIN_PREDEFINED_SEARCH',
  RESET_REDUCER_PREDEFINED_SEARCH = '@predefinedSearch/RESET_REDUCER_PREDEFINED_SEARCH'
}

export interface PredefinedSearchState {
  readonly predefinedSearch: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };

readonly domainPredefinedSearch: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetDomainPredefinedSearch {
  type: typeof PredefinedSearchTypes.GET_DOMAIN_PREDEFINED_SEARCH;
  payload: { routeUrl: string };
}

export interface SaveDomainPredefinedSearch {
  type: typeof PredefinedSearchTypes.SAVE_DOMAIN_PREDEFINED_SEARCH;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerPredefinedSearch  {
  type: typeof PredefinedSearchTypes.RESET_REDUCER_PREDEFINED_SEARCH;
}


export type PredefinedSearchActionTypes =
  | GetDomainPredefinedSearch
  | SaveDomainPredefinedSearch
  | ResetReducerPredefinedSearch;
